<template>
  <select
    v-model="selected"
    class="product-variant-select pointer"
    :title="title"
    @change="$emit('change', $event.target.value)">
    <template v-for="(option, index) of options">
      <option
        :key="`${option.optionValue}-${index}`"
        :value="option.optionValue">
        {{ option.optionText }}
      </option>
    </template>
  </select>
</template>

<script>
  export default {
    model: {
      event: `change`,
      prop: `value`,
    },
    data() {
      return {
        selected: ``,
      };
    },
    props: {
      defaultOption: {
        default: ``,
        type: String,
      },
      icon: {
        default: ``,
        type: String,
      },
      options: {
        default: () => [],
        type: Array,
      },
      title: {
        default: ``,
        type: String,
      },
    },
    mounted() {
      this.selected = _.find(this.options, { selected: true }).optionValue;
    },
    updated() {
      this.selected = _.find(this.options, { selected: true }).optionValue;
    },
  };
</script>

<style lang="less" scoped>
  @import '../../../assets/styles/rin-variables.less';

  .product-variant-select {
    background-color: inherit;
    background-position: calc(100% - 15px);
    background-repeat: no-repeat;
    border: 1px solid black;
    font-size: @fontSizeS;
    padding: 10px;

    @media @mobile {
      margin: 25px 0 0 0;
      width: 100%;
    }

    option {
      font-size: @fontSizeM;
    }
  }
</style>
